<template>
  <div id="app">
    <Router-View></Router-View>
    <audio
        ref="closed"
        :src=closedSound
        preload
        id="closed"
        muted
    ></audio>
    <div @click="playClosed()" class="toggle-sound"></div>
    <audio
        ref="connected"
        :src=connectedSound
        preload
        id="connected"
        muted
    ></audio>
    <div @click="playConnected()" class="toggle-sound"></div>
    <audio
        ref="disconnected"
        :src=disconnectSound
        preload
        id="disconnected"
        muted
    ></audio>
    <div @click="playDisconnected()" class="toggle-sound"></div>
    <audio
        ref="opened"
        :src=openedSound
        preload
        id="opened"
        muted
    ></audio>
    <div @click="playOpened()" class="toggle-sound"></div>
    <audio
        ref="suspend"
        :src=suspendSound
        preload
        id="suspend"
        muted
    ></audio>
    <div @click="playSuspend()" class="toggle-sound"></div>
    <audio
        ref="playnew"
        :src=newSound
        preload
        id="playnew"
        muted
    ></audio>
    <div @click="playNew()" class="toggle-sound"></div>
      <ChangePassword></ChangePassword>
  </div>
</template>
<script>
import appConfig from "@/app.config";
import authService from "@/services/authService";
const notificationSound = require("@/assets/sounds/notification.mp3");
const closedSound = require("@/assets/sounds/closed.mp3");
const connectedSound = require("@/assets/sounds/connected.mp3");
const disconnectSound = require("@/assets/sounds/disconnect.wav");
const openedSound = require("@/assets/sounds/opened.wav");
const suspendSound = require("@/assets/sounds/disconnect.wav");
const newSound = require("@/assets/sounds/new.mp3");
const catImage = require('@/assets/images/cat.gif');
const successIcon = require('@/assets/images/success_1.png');
const infoIcon = require('@/assets/images/info_1.png');
const warnIcon = require('@/assets/images/warning_1.png');
const errorIcon = require('@/assets/images/error_4.png');
const lostConnectionIcon = require('@/assets/images/error_3.png');
const mailIcon = require('@/assets/images/mail-icon.png');
import ChangePassword from "@/components/modals/admins/ChangePassword.vue";

export default {
  name: "app",
  data() {
    return {
      confirmMessage: this.$store.getters.confirmMessage,
      notifyMessage: this.$store.getters.notifyMessage,
      copy: this.$store.getters.copy,
      connected: this.$socket.connected,
      notificationSound,
      closedSound,
      connectedSound,
      disconnectSound,
      openedSound,
      suspendSound,
      newSound,
      catImage,
      successIcon,
      infoIcon,
      warnIcon,
      errorIcon,
      lostConnectionIcon,
      mailIcon
    }
  },
  sockets: {
    connect() {
    },
    notification(data) {
      this.$store.dispatch('getNotifyMessage', data)
    },
    confirm(data) {
      this.$store.dispatch('getConfirmMessage', data)
    },
    newData(data) {
      this.$store.dispatch('getNewData', data)
    }
  },
  page: {
    // All subcomponent titles will be injected into this template.
    titleTemplate(title) {
      title = typeof title === "function" ? title(this.$store) : title;
      return title ? `${title} | ${appConfig.title}` : appConfig.title;
    },

  },
  methods: {
    join() {
      authService.getToken()
      .then((res) => {
        if(res.state){
          this.$socket.client.emit('backoffice', {id: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9', token: this.$store.getters.token})
        }
      })
    },
    copyIt(){
      let input = document.createElement('textarea');
      input.innerHTML = this.copy.text;
      document.body.appendChild(input);
      input.select();
      let result = document.execCommand('copy');
      document.body.removeChild(input);
      this.$store.dispatch('getNotifyMessage', {siteConfirm: true, show:true, icon: 'success', title: 'Kopyalandı', message: this.copy.text})
      return result
    },
    sendConfirmMessage() {
        this.$swal({
          showConfirmButton: true,
          icon: this.confirmMessage.icon,
          title: this.confirmMessage.title,
          text: this.confirmMessage.message,
          confirmButtonText: 'OK',
          confirmButtonColor: '#3085d6',
        });
        this.$store.dispatch('getConfirmMessage', {show: false})
    },
    sendNotifyMessage() {
      let title = ''
      let message = ''
      if(!this.notifyMessage.message){
        title = ''
        message = this.notifyMessage.title
      }else{
        title = this.notifyMessage.title
        message = this.notifyMessage.message
      }
        if(this.notifyMessage.show && !this.notifyMessage.siteConfirm){
          let success = () => {
            this.$toast.success({
              title: title,
              message: message,
              position: 'top-left',
              icon : icon,
              progressBar: true,
              closeButton: true,
              timeOut: '10000'
            })
          }
          let error = () => {
            this.$toast.error({
              title: this.notifyMessage.title,
              message: this.notifyMessage.message,
              position: 'top-left',
              icon : icon,
              progressBar: true,
              closeButton: true,
              timeOut: '10000'
            })
          }
          let info = () => {
            this.$toast.info({
              title: this.notifyMessage.title,
              message: this.notifyMessage.message,
              position: 'top-left',
              icon : icon,
              progressBar: true,
              closeButton: true,
              timeOut: '10000'
            })
          }
          let warning = () => {
            this.$toast.warn({
              title: this.notifyMessage.title,
              message: this.notifyMessage.message,
              position: 'top-left',
              icon : icon,
              progressBar: true,
              closeButton: true,
              timeOut: '10000'
            })
          }

          let icon = ''
          if(this.notifyMessage.icon  === 'success') {
            icon = this.successIcon
            success()
          }
          else if(this.notifyMessage.icon  === 'error') {
            icon = this.errorIcon
            error()
          }
          else if(this.notifyMessage.icon  === 'info') {
            icon = this.infoIcon
            info()
          }
          else if(this.notifyMessage.icon  === 'warning') {
            icon = this.warnIcon
            warning()
          }
          else if(this.notifyMessage.icon  === 'disconnected') {
            icon = this.lostConnectionIcon
            error()
          }
          else if(this.notifyMessage.icon  === 'mail') {
            icon = this.infoIcon
            success()
          }
          else {
            icon = this.infoIcon
            info()
          }


        this.$store.dispatch('getNotifyMessage', {show: false})
      }
    },
    sendNotifyMessageSite() {
      if(this.notifyMessage.show && this.notifyMessage.siteConfirm){
        this.$swal({
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 3000,
          icon: this.notifyMessage.icon,
          title: this.notifyMessage.title,
          text: this.notifyMessage.message,
        });
        this.$store.dispatch('getNotifyMessage', {show: false})
      }

    },
    playNotification() {
      let note = new Audio(this.notificationSound);
        note.muted = false
        setTimeout(() => {
        note.play()
      },200)
    },
    playClosed() {
      let audio = this.$refs.closed;
      audio.play();
      document.querySelector(".toggle-sound").classList.remove("paused");

    },
    playConnected() {
      let audio = this.$refs.connected;
      audio.play();
      document.querySelector(".toggle-sound").classList.remove("paused");

    },
    playDisconnected() {
      let audio = this.$refs.disconnected;
      audio.play();
      document.querySelector(".toggle-sound").classList.remove("paused");

    },
    playOpened() {
      let audio = this.$refs.opened;
      audio.play();
      document.querySelector(".toggle-sound").classList.remove("paused");

    },
    playSuspend() {
      let audio = this.$refs.suspend;
      audio.play();
      document.querySelector(".toggle-sound").classList.remove("paused");

    },
    playNew() {
      let audio = this.$refs.playnew;
      audio.play();
      document.querySelector(".toggle-sound").classList.remove("paused");

    },
  },
  created() {
    this.join()
  },
  watch: {
    '$store.getters.copy': function() {
      if(this.$store.getters.copy.state)
      {
        this.copy = this.$store.getters.copy
        this.copyIt()
      }
    },
    '$store.getters.confirmMessage': function() {
      if(this.$store.getters.confirmMessage.show)
      {
        this.confirmMessage = this.$store.getters.confirmMessage
        this.sendConfirmMessage()
      }
    },
    '$store.getters.notifyMessage': function() {
      if(this.$store.getters.notifyMessage.show){
        this.notifyMessage = this.$store.getters.notifyMessage
        if(this.$store.getters.notifyMessage.siteConfirm){
          this.sendNotifyMessageSite()
        }else{
          this.sendNotifyMessage()
        }
      }
    },
    '$store.getters.token': function() {
      if(this.$store.getters.token){
        authService.getToken()
            .then((res) => {
              if(res.state){
                this.join()
              }
            })
      }
    },
    '$socket.connected': function() {
      this.connected = this.$socket.connected
    },
    '$store.getters.playNotification': function() {
      if(this.$store.getters.playNotification)
        this.playNotification()
      this.$store.dispatch('getPlayNotification', false)
    },
    '$store.getters.playDisconnected': function() {
      /*
            if(this.$store.getters.playDisconnected)
        this.playDisconnected()
      this.$store.dispatch('getPlayDisconnected', false)

       */
    },
    '$store.getters.playOpened': function() {
      if(this.$store.getters.playOpened)
        this.playOpened()
      this.$store.dispatch('getPlayOpened', false)
    },
    '$store.getters.playSuspend': function() {
      if(this.$store.getters.playSuspend)
        this.playSuspend()
      this.$store.dispatch('getPlaySuspend', false)
    },
    '$store.getters.playNew': function() {
      if(this.$store.getters.playNew)
        this.playNew()
        this.$store.dispatch('getPlayNew', false)
    },
    connected: function (){
      this.join()
      if(this.connected && this.$store.getters.token){
        this.$store.dispatch('getRealtimeConnect', true)
        this.$store.dispatch('getNotifyMessage', {siteConfirm: true, show: true, icon: 'success',message: '' ,title: 'Gerçek zamanlı bağlantı kuruldu.', })
        //this.playConnected()
      }else{
        //this.playClosed()
        this.$store.dispatch('getRealtimeConnect', false)
        this.$store.dispatch('getNotifyMessage', {siteConfirm: true, show: true, icon: 'error',message: '' ,title: 'Gerçek zamanlı bağlantı koptu. ', })
      }
    }

  },
  components: {ChangePassword}
};
</script>
<style>
.vs__selected-options {
  z-index: 1;
}
.vs--single .vs__selected {
  color: #fff;
}
.vs__actions .vs__clear {
  fill: #FFFFFF;
  padding: 0;
  border: 0;
  background-color: transparent;
  cursor: pointer;
  margin-right: 8px;
}
.vs__actions .vs__open-indicator {
  fill: #FFFFFF;
}
::-webkit-scrollbar {
  width:5px;
  height:5px;
}
::-webkit-scrollbar:hover{
  background-color: rgb(0, 0, 0)
}
::-webkit-scrollbar-track-piece  {
  background-color: #54586b;
  border-left: 1px solid #2a3142;
}
::-webkit-scrollbar-thumb:vertical {
  height: 15px;
  background-color: #17181d;
  border-left: 1px solid #404256;
  border-radius: 20px;
}
.vs__search, .vs__search:focus {
  color: #fff;
}
.container-fluid, .container-sm, .container-md, .container-lg, .container-xl, .navbar-header {
  max-width: 100%;
}
.vs__spinner {
  background: #fff;
}
/deep/.table {
  color: #fff;
}
::-webkit-scrollbar {
    width:10px;
    height:10px;
}
::-webkit-scrollbar-track-piece {
    border-left: 60px solid #2a3142;
}

</style>
